export const getTriggerRefPosition = ({ ref, menuWidth }) => {
  const position = ref.current?.getBoundingClientRect();
  const xOffset = position?.x + menuWidth > window.innerWidth ? menuWidth : 0;
  return { x: position?.right - xOffset, y: position?.bottom };
};
